import { jsx } from 'react/jsx-runtime';
import Helmet from 'react-helmet';

const DocumentHead = ({ title }) => (
// Social meta tags are handled by the backend, so it shouldn't be necessary
// to dynamically add or manipulate them here, aside from updating the page title
jsx(Helmet, { children: title && jsx("title", { children: `Sketch - ${title}` }) }));

export { DocumentHead };
